import { gql } from "@apollo/client"

export const GET_SAVED_BLOCKS = gql`
  query RecoveryPlanPage($participant_id: ID!, $organization_id: ID!) {
    blockSaved(
      participant_id: $participant_id
      block_name: "session__recovery_plan"
      organization_id: $organization_id
    ) {
      data
    }
  }
`

export const GET_USER = gql`
  query user($staff_id: ID!, $organization_id: ID!) {
    user(staff_id: $staff_id, organization_id: $organization_id) {
      staff_name_first
      staff_name_last
    }
  }
`

export const GET_STAFF_NAME = gql`
  query getStaffName($staff_id: ID!, $organization_id: ID!) {
    getStaffName(staff_id: $staff_id, organization_id: $organization_id) {
      data
    }
  }
`

export const GET_CUSTOM_FIELD = gql`
  query GetCustomField($idField: ID!, $type: ID!) {
    fieldByName(idField: $idField, type: $type) {
      idField
      field_name
      field_name_report
      description
      field_label
      field_description
      field_label_name
      field_type
      field_options {
        label
        value
      }
      field_validation {
        required
        number_min
        number_max
      }
      field_conditional
    }
  }
`
